// actionTypes.js
export const SET_VALUE_DOCS = "SET_VALUE_DOCS";
export const SET_CATEGORIE_DOCS = "SET_CATEGORIE_DOCS";
export const SET_TYPE_DOCS = "SET_TYPE_DOCS";
export const SET_CURRENT_PAGE_DOCS = "SET_CURRENT_PAGE_DOCS";
export const SET_ORDER_DOCS = "SET_ORDER_DOCS";
export const SET_SORT_FIELD_DOCS = "SET_SORT_FIELD_DOCS";
